<template>
  <v-app id="inspire" class="agent-layout-wrapper">
    <v-navigation-drawer
      class="sidebar"
      v-model="drawer"
      :clipped="false"
      :temporary="$vuetify.breakpoint.mdAndDown"
      :app="true"
      width="240"
      style="z-index: 200;"
    >
      <agent-drawer />
    </v-navigation-drawer>

    <v-app-bar
      app
      :flat="true"
      color="white"
      class="agent-top-nav"
      height="56"
    >
      <!-- Hamburger (mobile only) -->
      <v-app-bar-nav-icon
        class="tw-block lg:tw-hidden"
        color="primary"
        @click.stop="toggleDrawer"
      ></v-app-bar-nav-icon>

      <!-- Logo: mobile only, centered -->
      <router-link v-if="!drawer" :to="{ name: 'AgentDashboard' }" class="mobile-logo tw-block lg:tw-hidden">
        <img src="/pacis-logo.png" class="tw-block lg:tw-hidden tw-h-8 tw-w-auto tw-object-contain" alt="logo">
      </router-link>

      <!-- Page breadcrumb / title slot (desktop only) -->
      <div class="top-nav-center tw-hidden lg:tw-flex">
        <slot name="topbar-title"></slot>
      </div>

      <v-spacer></v-spacer>

      <!-- Right side: divider + notification + avatar -->
      <div class="tw-flex tw-items-center tw-gap-1 sm:tw-gap-3 tw-pr-1">
        <renewal-reminder-bell v-if="isAuthenticated" audience="agent" />
        <v-btn icon color="primary" :to="{ name: 'AgentMotorNotifications' }" class="tw-mr-1" @click="trackNotificationClick">
          <v-badge overlap color="red" dot offset-x="10" offset-y="10">
            <i class="ph ph-bell" style="font-size: 22px;"></i>
          </v-badge>
        </v-btn>
        <span class="nav-divider"></span>
        <avatar />
      </div>
    </v-app-bar>

    <v-main style="background-color: #F1F5F9; padding-top: 56px !important;" class="tw-min-h-screen">
      <v-container class="fill-height tw-items-start" style="padding: 0;" fluid>
        <div class="tw-w-full tw-px-4 md:tw-px-8 tw-pb-10">
          <slot></slot>
        </div>
      </v-container>
    </v-main>

    <screen-idle :dialog="isAppIdle" />
  </v-app>
</template>

<script>
import AgentDrawer from '@/components/layout/partials/AgentDrawer';
import Avatar from '@/components/layout/partials/nav/Avatar';
import { mapGetters } from 'vuex';
import ScreenIdle from '@/components/shared/ScreenIdle';
import { trackAgentInteraction, trackAgentPageView } from '@/utils/agentAnalytics';
import RenewalReminderBell from '@/components/renewals/RenewalReminderBell';

export default {
  name: 'AgentDefault',
  components: {
    ScreenIdle, Avatar, AgentDrawer, RenewalReminderBell,
  },
  data() {
    return {
      drawer: this.$vuetify.breakpoint ? !this.$vuetify.breakpoint.mdAndDown : null,
    };
  },
  mounted() {
    this.drawer = this.$vuetify.breakpoint.lgAndUp;
    trackAgentPageView(this, this.$route);
  },
  computed: {
    ...mapGetters('auth', ['authenticatedUser', 'isAuthenticated']),
  },
  watch: {
    $route(to, from) {
      if (to.fullPath !== from.fullPath) {
        trackAgentPageView(this, to);
      }
    },
  },
  methods: {
    toggleDrawer() {
      this.drawer = !this.drawer;
      trackAgentInteraction(this, 'toggle_mobile_drawer', {
        drawer_state: this.drawer ? 'open' : 'close',
      });
    },
    trackNotificationClick() {
      trackAgentInteraction(this, 'open_notifications', {
        destination: 'AgentMotorNotifications',
      });
    },
  },
};
</script>

<style scoped>
/* ── Sidebar gradient ── */
.sidebar {
  background-color: #1E4276 !important;
  background-image: linear-gradient(180deg, #1E4276 0%, #0d2a4e 100%) !important;
  border-right: none !important;
}

/* ── Top bar ── */
.agent-top-nav {
  z-index: 10;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05) !important;
}

/* Nav divider */
.nav-divider {
  display: inline-block;
  width: 1px;
  height: 24px;
  background: rgba(0, 0, 0, 0.1);
}

/* Desktop title slot */
.top-nav-center {
  align-items: center;
  height: 100%;
}

/* Mobile centered logo */
.mobile-logo {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  line-height: 0;
}

/* Phones: the right-hand icons need the space, so the logo sits beside the menu button. */
@media (max-width: 599px) {
  .mobile-logo {
    position: static;
    transform: none;
    margin-left: 2px;
  }

  .nav-divider {
    display: none;
  }
}

.mobile-logo-img {
  height: 30px;
  width: auto;
  display: block;
}
</style>

<!-- Global: override Vuetify navigation drawer background -->
<style>
.v-navigation-drawer.sidebar {
  background-color: #1E4276 !important;
  background-image: linear-gradient(180deg, #1E4276 0%, #0d2a4e 100%) !important;
}

/* Keep app bar shadow clean */
.agent-top-nav.v-app-bar {
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05) !important;
}

/* Override Vuetify's default list item active state inside our drawer */
.sidebar .v-list-item--active {
  background: rgba(0, 174, 239, 0.15) !important;
}

@media (max-width: 1264px) {
  .v-navigation-drawer.sidebar {
    top: 0 !important;
    height: 100% !important;
    padding-top: 0 !important;
  }
}

@media (min-width: 1264px) {
  .agent-layout-wrapper .v-main {
    padding-left: 240px !important;
  }
}
</style>

<!-- Global: override Vuetify navigation drawer background -->
<style>
.v-navigation-drawer.sidebar {
  background-color: #1E4276 !important;
  background-image: linear-gradient(180deg, #1E4276 0%, #0d2a4e 100%) !important;
}

/* Keep app bar shadow clean */
.agent-top-nav.v-app-bar {
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05) !important;
}

/* Override Vuetify's default list item active state inside our drawer */
.sidebar .v-list-item--active {
  background: rgba(0, 174, 239, 0.15) !important;
}
</style>
